import {GroupMenuActionTypes, SELECT_GROUP} from "./types";
import Group from "../../model/group/group";

export function selectGroup(group: Group): GroupMenuActionTypes {
    return {
        type: SELECT_GROUP,
        group: group,
    }
}
